import _ from "lodash";
import React from "react";
import { connect } from "react-redux";
import IntlMessages from "util/intlMessages";
import { setOnChange } from "components/special";
import { FloatSpecialsCategories } from "components/special/contents";
import { ChanneslWithScore } from "components/standart";

const ContentData = (props) => {
  const { content, setContent } = props;

  const changeContent = setOnChange(content, setContent);

  return (
    <div>
      <div className="form-group row">
        <label className="col-4 col-form-label">
          <IntlMessages id="Specials.Casts.name" />
        </label>
        <div className="col-8">
          <input
            type="text"
            name="name"
            value={content.name || ""}
            onChange={changeContent}
            className="form-control react-form-input"
            autoComplete="off"
            required
          />
        </div>
      </div>

      <div className="form-group row">
        <div className="col-4 col-form-label">
          <IntlMessages id="OpenAI.Schedules.channels" />
          <ChanneslWithScore.AddButton
            className="btn-sm float-right"
            values={content.channelsWithScore}
            changeValues={(channelsWithScore) => setContent({ ...content, channelsWithScore })}
          />
        </div>
        <div className="col-8">
          <ChanneslWithScore
            values={content.channelsWithScore}
            changeValues={(channelsWithScore) => setContent({ ...content, channelsWithScore })}
          />
        </div>
      </div>

      <div className="form-group row">
        <label className="col-4 col-form-label">
          <IntlMessages id="Specials.Casts.promptRole" />
        </label>
        <div className="col-8">
          <input
            type="text"
            name="promptRole"
            value={content.promptRole || ""}
            onChange={changeContent}
            className="form-control react-form-input"
            autoComplete="off"
            required
          />
        </div>
      </div>

      <div className="form-group row">
        <label className="col-4 col-form-label">
          <IntlMessages id="Specials.Casts.category" />
        </label>
        <div className="col-8">
          <FloatSpecialsCategories
            _id={content.categoryId}
            multi={false}
            showTitle={true}
            showCount={false}
            className="btn-sm"
            successHandler={([categoryId = null]) => {
              setContent({ ...content, categoryId });
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default connect(null, {})(ContentData);
